import React, { Component } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";
import pickBy from "lodash/pickBy";
import Multiselect from "components/Multiselect";
import { Dropdown } from "components/Dropdown/Dropdown";
import { CustomDateRange } from "components/date-range/index";
import { AppSettings } from "../../constants";
import Translate from "components/translate";
import { connect } from "react-redux";
import { Panel } from "react-bootstrap";

const convertStringMultiParamsToSelectedOption = (stringParams) => {
  let selectedOption = [];
  if (stringParams) {
    const parsedParams = queryString.parse(stringParams);

    Object.keys(parsedParams).map((el) => {
      selectedOption.push(queryString.parse(parsedParams[el]));
    });
  }
  return selectedOption;
};

const AssignedModeValues = [
  {
    value: "Assigned",
    text: "Assigned",
  },
  {
    value: "UnAssigned",
    text: "UnAssigned",
  },
];

// const defaultStatusSelectList = [
//   { value: 'Open', key: 0 },
//   { value: 'Declined', key: 1 },
//   { value: 'Closed', key: 2 },
//   { value: 'New', key: 3 },
//   { value: 'Scheduled', key: 4 }
// ];
const defaultStatusSelectList = AppSettings.RFS_STATUS_VALUE;

class RFSFilter extends Component {
  static propTypes = {
    RegionSelectList: PropTypes.array,
    RequestTypeSelectList: PropTypes.array,
    onFetchRegion: PropTypes.func,
    MarketSelectList: PropTypes.array,
    onFetchMarket: PropTypes.func,
    ProjectSelectList: PropTypes.array,
    RFSManagedBySelectList: PropTypes.array,
    LotSelectList: PropTypes.array,
    onFetchProject: PropTypes.func,
    onSearchRFS: PropTypes.func,
    onFetchRFSManagedBy: PropTypes.func,
    onFetchRequestType: PropTypes.func,
    onFetchLot: PropTypes.func,
    sso: PropTypes.bool,
    location: PropTypes.object,
    CreatedByList: PropTypes.array,
    ManagerStore: PropTypes.object,
  };

  static defaultProps = {
    RFSManagedBySelectList: [],
  };

  constructor(props) {
    super(props);

    this.queryParams = queryString.parse(props.location.search);

    this.state = {
      region: convertStringMultiParamsToSelectedOption(
        this.queryParams.inRegions
      ),
      isLoadingRegion: false,
      market: convertStringMultiParamsToSelectedOption(
        this.queryParams.inMarkets
      ),
      isLoadingMarket: false,
      project: convertStringMultiParamsToSelectedOption(
        this.queryParams.inProjects
      ),
      isLoadingProject: false,
      RFSManagedBy: convertStringMultiParamsToSelectedOption(
        this.queryParams.inRFSManagedBy
      ),
      isLoadingRFSManagedBy: false,
      lot: this.queryParams.inLot
        ? queryString.parse(this.queryParams.inLot)
        : null,
      isLoadingLot: false,
      requestType: convertStringMultiParamsToSelectedOption(
        this.queryParams.inRequestTypes
      ),
      createdDate:
        this.queryParams.CreatedDateFrom && this.queryParams.CreatedDateFrom
          ? {
              from: this.queryParams.CreatedDateFrom,
              to: this.queryParams.CreatedDateTo,
              optionType: this.queryParams.CreatedDateType,
            }
          : null,
      statusSelectList: defaultStatusSelectList,
      status: this.queryParams.Status
        ? defaultStatusSelectList
            .map((item) => ({
              label: item.value,
              value: item.key,
            }))
            .filter((x) => this.queryParams.Status.includes(x.value))
        : [],
      createdBy: this.queryParams.inCreatedBy
        ? queryString.parse(this.queryParams.inCreatedBy)
        : null,
      isCreatedByLoading: false,
      WOAssignedMode: this.queryParams.RFSWOAssignedMode
        ? AssignedModeValues.find(
            (item) => item.value == this.queryParams.RFSWOAssignedMode
          )
        : null,
      RfsDefaultConfig: this.queryParams.NewRFSFilterFromTiles == "True" ? false : true,
      panelToggle:
        this.queryParams.inRegions ||
        this.queryParams.inMarkets ||
        this.queryParams.CreatedDateFrom ||
        this.queryParams.ClosedDateFrom ||
        this.queryParams.ResolvedDateFrom
          ? true
          : false,
    };
  }

  componentDidMount() {
    if (this.state.RfsDefaultConfig == true) {
      this.props.onSearchRFS(this.mapParams());
    }
    
    document.addEventListener("mousedown", this.handleHideDateRange);
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.RfsDefaultConfig == true){
    const ManageRFSs = nextProps.ManagerStore.ManageRFS;    
    let statusValue = []
    var array = JSON.parse("[" + ManageRFSs.params.appliedFilterStatus + "]");
  
    if (ManageRFSs) {
      let filteredArray = array.includes(null);
      if(!filteredArray){
        array.map((item) => {
          statusValue.push(AppSettings.RFS_STATUS_VALUE.find((x) => x.key == item))
          this.setState({
            status: statusValue.map((item) => ({
              label: item.value,
              value: item.key,
              }))
          })
        });
      }
      this.setState({
        WOAssignedMode: ManageRFSs.params.rfswoAssignedModeOrWOType ? AssignedModeValues.find((item) => item.value == ManageRFSs.params.rfswoAssignedModeOrWOType ) : AssignedModeValues.find((item) => item.value ==  'UnAssigned' ),
      })
    }
  }

    if (nextProps.RegionSelectList && this.state.isLoadingRegion) {
      this.setState({ isLoadingRegion: false });
    }
    if (nextProps.MarketSelectList && this.state.isLoadingMarket) {
      this.setState({ isLoadingMarket: false });
    }
    if (nextProps.ProjectSelectList && this.state.isLoadingProject) {
      this.setState({ isLoadingProject: false });
    }
    if (nextProps.RFSManagedBySelectList && this.state.isLoadingRFSManagedBy) {
      this.setState({ isLoadingRFSManagedBy: false });
    }
    if (nextProps.RequestTypeSelectList && this.state.isLoadingRequestType) {
      this.setState({ isLoadingRequestType: false });
    }
    if (nextProps.LotSelectList && this.state.isLoadingLot) {
      this.setState({ isLoadingLot: false });
    }

    const prevUrlParams = queryString.parse(this.props.location.search);
    const nextUrlParams = queryString.parse(nextProps.location.search);

    if (nextUrlParams.inProjects !== prevUrlParams.inProjects) {
      this.setState({
        project: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inProjects
        ),
      });
    }

    if (nextUrlParams.inRFSManagedBy !== prevUrlParams.inRFSManagedBy) {
      this.setState({
        RFSManagedBy: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inRFSManagedBy
        ),
      });
    }

    if (nextUrlParams.inRegions !== prevUrlParams.inRegions) {
      this.setState({
        region: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inRegions
        ),
      });
    }

    if (nextUrlParams.inMarkets !== prevUrlParams.inMarkets) {
      this.setState({
        market: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inMarkets
        ),
      });
    }

    if (nextUrlParams.inRequestTypes !== prevUrlParams.inRequestTypes) {
      this.setState({
        requestType: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inRequestTypes
        ),
      });
    }

    if (nextUrlParams.Status !== prevUrlParams.Status) {
      if (nextUrlParams.Status) {
        this.setState({
          status: defaultStatusSelectList
            .map((item) => ({
              label: item.value,
              value: item.key,
            }))
            .filter((x) => nextUrlParams.Status.includes(x.value)),
        });
      } else {
        this.setState({ status: [] });
      }
    }

    if (nextUrlParams.inLot !== prevUrlParams.inLot) {
      this.setState({
        lot: nextUrlParams.inLot
          ? queryString.parse(nextUrlParams.inLot)
          : null,
      });
    }
    if (nextProps.CreatedByList && this.state.isCreatedByLoading) {
      this.setState({ isCreatedByLoading: false });
    }
    if (nextUrlParams.inCreatedBy !== prevUrlParams.inCreatedBy) {
      this.setState({
        createdBy: nextUrlParams.inCreatedBy
          ? queryString.parse(nextUrlParams.inCreatedBy)
          : null,
      });
    }
    if (nextProps.RFSWOAssignedMode !== prevUrlParams.rfswoAssignedModeOrWOType) {
      this.setState({WOAssignedMode: nextUrlParams.RFSWOAssignedMode ? AssignedModeValues.find((item) => item.value == nextUrlParams.RFSWOAssignedMode ): '' })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleHideDateRange);
  }

  onFetchRegion = () => {
    this.setState(
      {
        isLoadingRegion: true,
      },
      () => {
        this.props.onFetchRegion({
          projectId: this.state.project.map((el) => el.value),
          marketId: this.state.market.map((el) => el.value),
          lotId: this.state.lot ? this.state.lot.value : "",
        });
      }
    );
  };

  onFetchRequestType = () => {
    this.setState(
      {
        isLoadingRequestType: true,
      },
      () => {
        this.props.onFetchRequestType();
      }
    );
  };

  onSelectRegion = (value) => {
    this.setState(
      {
        region: value,
        RfsDefaultConfig: false,
        NewRFSFilterFromTiles: '0'
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSelectAssignMode = (value) => {
    this.setState(
      {
        WOAssignedMode: value,
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSelectRequestType = (value) => {
    this.setState(
      {
        requestType: value,
        RfsDefaultConfig: false,
        NewRFSFilterFromTiles: '0'
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onFetchMarket = () => {
    this.setState(
      {
        isLoadingMarket: true,
      },
      () => {
        this.props.onFetchMarket({
          projectId: this.state.project.map((el) => el.value),
          regionId: this.state.region.map((el) => el.value),
          lotId: this.state.lot ? this.state.lot.value : "",
        });
      }
    );
  };

  onSelectMarket = (value) => {
    this.setState(
      {
        market: value,
        RfsDefaultConfig: false,
        NewRFSFilterFromTiles: '0'
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onFetchProject = () => {
    this.setState(
      {
        isLoadingProject: true,
      },
      () => {
        this.props.onFetchProject({
          regionId: this.state.region.map((el) => el.value),
          marketId: this.state.market.map((el) => el.value),
          lotId: this.state.lot ? this.state.lot.value : "",
        });
      }
    );
  };

  onSelectProject = (value) => {
    this.setState(
      {
        project: value,
        RfsDefaultConfig: false,
        NewRFSFilterFromTiles: '0'
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onFetchLot = () => {
    this.setState(
      {
        isLoadingLot: true,
      },
      () => {
        this.props.onFetchLot({
          regionId: this.state.region.map((el) => el.value),
          marketId: this.state.market.map((el) => el.value),
          projectId: this.state.project.map((el) => el.value),
        });
      }
    );
  };
  onFetchCreatedBy = () => {
    this.setState(
      {
        isCreatedByLoading: true,
      },
      () => {
        this.props.onFetchCreatedBy({
          regionId: this.state.region.map((el) => el.value),
          marketId: this.state.market.map((el) => el.value),
          projectId: this.state.project.map((el) => el.value),
        });
      }
    );
  };
  onSelectLot = (value) => {
    this.setState(
      {
        lot: value,
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSelectStatus = (value) => {
    this.setState(
      {
        status: value,
        RfsDefaultConfig: false,
        NewRFSFilterFromTiles: '0'
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onFetchRFSManagedBy = () => {
    this.setState(
      {
        isLoadingRFSManagedBy: true,
      },
      () => {
        this.props.onFetchRFSManagedBy();
      }
    );
  };

  onSelectRFSManagedBy = (value) => {
    this.setState(
      {
        RFSManagedBy: value,
        RfsDefaultConfig: false,
        NewRFSFilterFromTiles: '0'
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSaveCreationDate = (fromDate, toDate, optionType) => {
    if (fromDate && toDate) {
      this.setState(
        {
          createdDate: {
            from: fromDate,
            to: toDate,
            optionType: optionType.value,
          },
          RfsDefaultConfig: false,
          NewRFSFilterFromTiles: '0'
        },
        () => {
          this.props.onSearchRFS(this.mapParams());
        }
      );
    } else {
      this.setState(
        {
          createdDate: null,
        },
        () => {
          this.props.onSearchRFS(this.mapParams());
        }
      );
    }
  };

  onSelectChange = (event, name) => {
    this.setState(
      {
        [name]: event.value,
        RfsDefaultConfig: false,
        NewRFSFilterFromTiles: '0'
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  mapParams = () => {
    let params = {};
    
    if (this.state.region.length > 0) {
      params["inRegions"] = queryString.stringify([
        ...this.state.region.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.market.length > 0) {
      params["inMarkets"] = queryString.stringify([
        ...this.state.market.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.project.length > 0) {
      params["inProjects"] = queryString.stringify([
        ...this.state.project.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.RFSManagedBy.length > 0) {
      params["inRFSManagedBy"] = queryString.stringify([
        ...this.state.RFSManagedBy.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.requestType.length > 0) {
      params["inRequestTypes"] = queryString.stringify([
        ...this.state.requestType.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.lot) {
      params["inLot"] = queryString.stringify(pickBy({ ...this.state.lot }));
    }

    if (this.state.WOAssignedMode) {
      params["RFSWOAssignedMode"] = this.state.WOAssignedMode.text;
    }

    if (this.state.createdBy) {
      params["inCreatedBy"] = queryString.stringify(
        pickBy({ ...this.state.createdBy })
      );
    }
    const statuses = [];
    if (this.state.status.length > 0) {
      this.state.status.map((e) => {
        statuses.push(e.value);
      });
    }
    statuses.length
      ? (params["Status"] = statuses.toString())
      : (params["Status"] = "");

    if (this.state.createdDate) {
      params["CreatedDateFrom"] = this.state.createdDate.from;
      params["CreatedDateTo"] = this.state.createdDate.to;
      params["CreatedDateType"] = this.state.createdDate.optionType;
    } else {
      params["CreatedDateFrom"] = "";
      params["CreatedDateTo"] = "";
    }

    params["RfsDefaultConfig"] = this.state.RfsDefaultConfig ;

    if (this.state.NewRFSFilterFromTiles) {
      params["NewRFSFilterFromTiles"] = this.state.NewRFSFilterFromTiles ;
    }
    
    
    
    return params;
  };

  renderUserOption = (userList) => {
    if (userList.length) {
      if (this.props.sso) {
        let systemUsers = [];
        let builderUsers = [];

        userList.map((item) => {
          if (item.extensionValue.sso) {
            systemUsers.push(item);
          } else {
            builderUsers.push(item);
          }
        });

        let options = [
          {
            label: "System users",
            options: systemUsers,
          },
          {
            label: "Builder users",
            options: builderUsers,
          },
        ];

        return options;
      } else {
        return userList;
      }
    } else {
      return [];
    }
  };

  render() {
    const urlParams = queryString.parse(this.props.location.search);

    return (
      <div className="lot-filter-wrapper box-form-siteone clearfix center-col">
        <h2 className="col-sm-12" style={{ fontSize: 20, fontWeight: 400 }}>
          Filters
        </h2>
        <div className="row" style={{ paddingLeft: 15, paddingRight: 15 }}>
          {/*
           * Regions dropdown
           */}
          {(AppSettings.REGION_AND_MARKET ===
            AppSettings.RegionAndMarket.REGION ||
            AppSettings.REGION_AND_MARKET ===
              AppSettings.RegionAndMarket.REGION_AND_MARKET) && (
            <div className="col-sm-2 lot-filter-block">
              <label className="col-sm-12 control-label">
                <Translate translateKey="region" plurals capitalize />
              </label>
              <div className="col-sm-12 control-label">
                <Multiselect
                  placeholder="Any"
                  items={this.props.RegionSelectList.map((item) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                  value={this.state.region}
                  onChange={this.onSelectRegion}
                  onRemote={this.onFetchRegion}
                  isLoading={this.state.isLoadingRegion}
                  ref={(ref) => {
                    this.project = ref;
                  }}
                />
              </div>
            </div>
          )}

          {/*
           * Markets dropdown
           */}
          {AppSettings.REGION_AND_MARKET ===
            AppSettings.RegionAndMarket.REGION_AND_MARKET && (
            <div className="col-sm-2 lot-filter-block">
              <label className="col-sm-12 control-label">
                <Translate translateKey="market" plurals capitalize />
              </label>
              <div className="col-sm-12 control-label">
                <Multiselect
                  placeholder="Any"
                  isMulti={false}
                  items={this.props.MarketSelectList.map((item) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                  value={this.state.market}
                  onChange={this.onSelectMarket}
                  onRemote={this.onFetchMarket}
                  isLoading={this.state.isLoadingMarket}
                  ref={(ref) => {
                    this.project = ref;
                  }}
                />
              </div>  
            </div> 
            )}
            {/* </Panel.Body>
          </Panel.Collapse>

          <Panel.Footer
            style={{ backgroundColor: "#fff", paddingTop: 0, borderTop: 0 }}
          >
            <div style={{ paddingTop: 0, paddingBottom: 0 }}>
              {this.state.panelToggle ? (
                <div>
                  <span
                    onClick={() => {
                      this.setState({ panelToggle: !this.state.panelToggle });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa fa-chevron-circle-up" /> Less
                  </span>
                </div>
              ) : (
                <div>
                  <span
                    onClick={() => {
                      this.setState({ panelToggle: !this.state.panelToggle });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                  <i className="fa fa-chevron-circle-down" /> More
                </span>
              </div>
            )}
            </div> */}
         

          {/*
           * Projects dropdown
           */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">
              <Translate translateKey="project" plurals capitalize />
            </label>
            <div className="col-sm-12 control-label">
              <Multiselect
                placeholder="Any"
                items={this.props.ProjectSelectList.map((item) => ({
                  label: item.text,
                  value: item.value,
                }))}
                value={this.state.project}
                onChange={this.onSelectProject}
                onRemote={this.onFetchProject}
                isLoading={this.state.isLoadingProject}
                ref={(ref) => {
                  this.project = ref;
                }}
              />
            </div>
          </div>

          {/*
           * Statuses dropdown
           */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">Status</label>
            <div className="col-sm-12 control-label">
              <Multiselect
                placeholder="Any"
                items={AppSettings.RFS_STATUS_VALUE.map((item) => ({
                  label: item.value,
                  value: item.key,
                }))}
                value={this.state.status}
                onChange={this.onSelectStatus}
                ref={(ref) => {
                  this.status = ref;
                }}
              />
            </div>
          </div>
          {/*
           * Lots dropdown
           */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">Lot</label>
            <div className="col-sm-12 control-label">
              <Dropdown
                filter={true}
                onChange={(ref) => {
                  this.onSelectChange(ref, "lot");
                }}
                className="filestring-dropdown filter-dropdown"
                optionLabel="text"
                placeholder="Any"
                style={{ width: "100%" }}
                options={
                  this.props.LotSelectList.length > 0
                    ? this.props.LotSelectList
                    : [{ ...this.state.lot }]
                }
                loading={this.state.isLoadingLot}
                onRemote={this.onFetchLot}
                showClear={true}
                value={this.state.lot}
              />
            </div>
          </div>
          {/*
           * Created by dropdown
           */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">Created by</label>
            <div className="col-sm-12 control-label">
              <Dropdown
                filter={true}
                onChange={(ref) => {
                  this.onSelectChange(ref, "createdBy");
                }}
                className="filestring-dropdown filter-dropdown"
                optionLabel="text"
                placeholder="Any"
                style={{ width: "100%" }}
                options={
                  this.props.CreatedByList.length > 0
                    ? this.props.CreatedByList
                    : [{ ...this.state.createdBy }]
                }
                loading={this.state.isCreatedByLoading}
                onRemote={this.onFetchCreatedBy}
                showClear={true}
                value={this.state.createdBy}
              />
            </div>
          </div>
        </div>
        <div className="row" style={{ paddingLeft: 15, paddingRight: 15 }}>
          {/*
           * RFS managed by dropdown
           */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">RFS managed by</label>
            <div className="col-sm-12 control-label">
              <Multiselect
                placeholder="Any"
                items={this.renderUserOption(this.props.RFSManagedBySelectList)}
                labelKey="text"
                value={this.state.RFSManagedBy}
                onChange={this.onSelectRFSManagedBy}
                onRemote={this.onFetchRFSManagedBy}
                isLoading={this.state.isLoadingRFSManagedBy}
                ref={(ref) => {
                  this.RFSManagedBy = ref;
                }}
              />
            </div>
          </div>
          {/* <div className="row" style={{ paddingLeft: 15, paddingRight: 15 }}> */}
          {/*
           * Projects dropdown
           */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">Request types</label>
            <div className="col-sm-12 control-label">
              <Multiselect
                placeholder="Any"
                items={this.props.RequestTypeSelectList.map((item) => ({
                  label: item.text,
                  value: item.value,
                }))}
                value={this.state.requestType}
                onChange={this.onSelectRequestType}
                onRemote={this.onFetchRequestType}
                isLoading={this.state.isLoadingRequestType}
                ref={(ref) => {
                  this.requestType = ref;
                }}
              />
            </div>
          </div>

          {/*
           * Creation date dropdown
           */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">Creation date</label>
            <CustomDateRange
              className="col-sm-12"
              startDate={
                urlParams.CreatedDateFrom ? urlParams.CreatedDateFrom : null
              }
              endDate={urlParams.CreatedDateTo ? urlParams.CreatedDateTo : null}
              optionType={
                urlParams.CreatedDateType ? urlParams.CreatedDateType : null
              }
              onSave={this.onSaveCreationDate}
            />
          </div>
          {/* Assigned and Unassign WO */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">Work Order status</label>
            <div className="col-sm-12 control-label">
              <Dropdown
                filter={true}
                onChange={(ref) => {
                  this.onSelectChange(ref, "WOAssignedMode");
                }}
                className="filestring-dropdown filter-dropdown"
                options={AssignedModeValues}
                optionLabel="text"
                placeholder="Any "
                style={{ width: "100%" }}
                ref={(ref) => {
                  this.AssignedMode = ref;
                }}
                showClear={true}
                value={this.state.WOAssignedMode}
                name="WOAssignedMode"
              />
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ManagerStore: state.RFSStore,
  };
};

export default connect(mapStateToProps)(RFSFilter);


// WEBPACK FOOTER //
// ./src/Request-Services/Components/RFSFilter.js